import { render } from "./SettingsActivity.vue?vue&type=template&id=3aa7f363&scoped=true"
import script from "./SettingsActivity.vue?vue&type=script&lang=js"
export * from "./SettingsActivity.vue?vue&type=script&lang=js"

import "./SettingsActivity.vue?vue&type=style&index=0&id=3aa7f363&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa7f363"]])

export default __exports__